<script>
	export default {
		onLaunch: function() {
			console.log('App Launch')
		},
		onShow: function() {
			// var that = this;
			// uni.login({
			// 	provider: 'weixin',
			// 	success: async function (loginRes) {
			// 		let { code } = loginRes;
			// 		let res = await that.$u.api.loginByWxMini({ code })
			// 		if (!res.data) {
			// 			uni.navigateTo({
			// 				url: '/pages/login/login'
			// 			})
			// 		}
			// 	}
			// });
		},
		onHide: function() {
			console.log('App Hide')
		}
	}
</script>

<style lang="scss">
	/*每个页面公共css */
	@import "uview-ui/index.scss";
</style>
